import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { UserGroupDTO } from '../../../../dto/user-group/user-group.dto';

const EVENT_PREFIX = 'duna-user-groups';

export function duna_user_groups(componentDataSourceService: ComponentDataSourceService) {
  const maintenanceTransform = (value: number, row?: UserGroupDTO) => {
    if (value === undefined || value === null) return 'N/A';
    const intended = Math.min(100, Math.max(0, value));
    const participated = Math.min(100, Math.max(0, row?.progress_percentage || 0));
    return `${intended}% (${participated}%)`;
  };

  return {
    name: 'DUNA Brugergrupperinger',
    description: 'Liste over brugergrupperinger i organisationen',
    execute: (params?: LoadDataParams): Observable<any> => {
      return componentDataSourceService['loadDataWithStandardFiltersGET'](
        'duna_user_groups',
        '/user-groups',
        params ?? ({} as LoadDataParams)
      ).pipe(
        catchError(error => {
          console.error('[duna_user_groups] Error fetching groups:', error);
          return of({ items: [], totalCount: 0, pageSize: 10, pageIndex: 0 });
        }),
        map(result => ({
          items: (result?.items || []) as UserGroupDTO[],
          totalCount: result?.totalCount ?? 0,
          pageSize: result?.pageSize ?? 10,
          pageIndex: result?.pageIndex ?? 0,
        }))
      );
    },
    settings: {
      columns: [
        { key: 'name', header: 'Navn', type: 'text', sortable: true, wrap: true },
        { key: 'description', header: 'Beskrivelse', type: 'text', sortable: true, wrap: true },
        { key: 'member_count', header: 'Antal brugere', type: 'number', sortable: true, alignment: 'center' },
        {
          key: 'ok_percentage',
          header: 'STATUS (%)',
          type: 'text',
          transform: (value: number) => `${value ?? 0}%`,
          sortable: true,
          alignment: 'left',
        },
        {
          key: 'registered_percentage',
          header: 'Tilmeldte',
          type: 'text',
          transform: maintenanceTransform,
          sortable: true,
          alignment: 'left',
        },
        {
          key: 'view_members',
          header: '',
          type: 'button',
          buttonText: 'Se brugere',
          buttonColor: 'primary',
          variant: 'stroked',
          alignment: 'right',
          action: (row: UserGroupDTO) => {
            window.dispatchEvent(new CustomEvent(`${EVENT_PREFIX}-view-members`, { detail: row }));
          },
        },
        {
          key: 'manage_members',
          header: '',
          type: 'button',
          buttonText: 'Administrer',
          buttonColor: 'accent',
          variant: 'stroked',
          alignment: 'right',
          action: (row: UserGroupDTO) => {
            window.dispatchEvent(new CustomEvent(`${EVENT_PREFIX}-manage-members`, { detail: row }));
          },
        },
        {
          key: 'edit_group',
          header: '',
          type: 'button',
          buttonText: 'Rediger',
          buttonColor: 'primary',
          variant: 'stroked',
          alignment: 'right',
          action: (row: UserGroupDTO) => {
            window.dispatchEvent(new CustomEvent(`${EVENT_PREFIX}-edit`, { detail: row }));
          },
        },
        {
          key: 'delete_group',
          header: '',
          type: 'button',
          buttonText: 'Slet',
          buttonColor: 'warn',
          variant: 'stroked',
          alignment: 'right',
          action: (row: UserGroupDTO) => {
            window.dispatchEvent(new CustomEvent(`${EVENT_PREFIX}-delete`, { detail: row }));
          },
        },
      ],
      pageable: true,
      sortable: true,
      rowHover: true,
      searchable: true,
      defaultSortColumn: 'member_count',
      defaultSortDirection: 'desc',
    },
  };
}
